import { useState, useEffect } from 'react';

interface UseProgressTrackingProps {
  messages: Array<{ isUser: boolean; content: string }>;
  resumeData: any;
}

export function useProgressTracking({ messages, resumeData }: UseProgressTrackingProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const calculateProgress = () => {
      if (!resumeData) return 0;
      
      let progress = 0;
      
      // Check if personal info form was submitted (35%)
      const hasPersonalInfo = resumeData.fullName || resumeData.email || resumeData.jobTitle;
      if (hasPersonalInfo) {
        progress += 35;
      }
      
      // Check if work experience form was submitted (30%)
      const hasWorkExperience = resumeData.workExperience || resumeData.experience;
      if (hasWorkExperience && Array.isArray(hasWorkExperience) && hasWorkExperience.length > 0) {
        progress += 30;
      }
      
      // Check if education/skills form was submitted (35%)
      const hasEducation = resumeData.education;
      const hasSkills = resumeData.skills;
      if ((hasEducation && Array.isArray(hasEducation) && hasEducation.length > 0) || 
          (hasSkills && Array.isArray(hasSkills) && hasSkills.length > 0)) {
        progress += 35;
      }
      
      return Math.min(progress, 100);
    };

    setProgress(calculateProgress());
  }, [messages, resumeData]);

  return progress;
}